export default __webpack_public_path__ + "static/media/BH Icons 30 p_Ironing.128e4f2a.svg";